import { Typography } from "antd"

const { Text } = Typography;

const DealDetailNoSpace = ({ label, value, recourseTag }) => {
    return (
        <Text>
            <strong>{label}:</strong>
            {" "}
            {value}
            {" "}
            {recourseTag && recourseTag}
        </Text>
    )
}

export default DealDetailNoSpace